import Tooltip from 'antd/es/tooltip';

export default Tooltip;
